package com.example.histoire.web

/**
 * Définir dans [index.html] (ou injecter au build, ex. Cloudflare Pages) :
 * `window.HISTOIRE_SUPABASE_URL = "https://xxxx.supabase.co";`
 * `window.HISTOIRE_SUPABASE_ANON_KEY = "eyJ...";`
 *
 * Dashboard : Authentication → Providers → activer **Email** (connexion par lien magique).
 * Tu peux désactiver **Anonymous sign-ins** : l’app « standard » utilise l’e-mail + lien (flux implicite, lisible après clic même depuis l’app Mail).
 * Domaine / Redirect URLs : voir [supabase/PRODUCTION_CHECKLIST.txt].
 */
fun isSupabaseWebConfigured(): Boolean =
    !supabaseWebUrl().isNullOrBlank() && !supabaseWebAnonKey().isNullOrBlank()

fun supabaseWebUrl(): String? =
    readWindowString("HISTOIRE_SUPABASE_URL")?.trimEnd('/')?.takeIf { it.isNotBlank() }

fun supabaseWebAnonKey(): String? =
    readWindowString("HISTOIRE_SUPABASE_ANON_KEY")?.trim()?.takeIf { it.isNotBlank() }

@Suppress("UNUSED_VARIABLE")
private fun readWindowString(name: String): String? {
    val v: dynamic = js("typeof window !== 'undefined' ? window[name] : null")
    return v as? String
}
